import React, { useState, useEffect, useRef } from "react";
import Grid from "@mui/material/Grid2";

import { 
  Campaign,
  CampaignNote, 
} from "@dndModels";

import AddButton from "@components/input/buttons/AddButton";
import CampaignNoteInput from "./CampaignNoteInput";
import DandDAPI from "@dndUtilities/system_api";

interface Props {
  obj: Campaign;
}

const api = DandDAPI.getInstance();

export default function CampaignNotesInput({ obj }: Props) {
  const [ping, setPing] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <Grid container spacing={0} direction="row">
      <Grid size={12}>
        <AddButton label="Add Note" 
          disabled={processing}
          onClick={ async () => {
            const new_note = new CampaignNote();
            new_note.campaign_id = obj._id;
            setProcessing(true);
            await api.upsertObject("campaign_note", new_note);
            obj.notes.push(new_note);
            setProcessing(false);
          }}
        />
      </Grid>
      { obj.notes.map(note => {
        return (
          <Grid size={12} key={note._id}>
            <CampaignNoteInput
              obj={obj}
              note={note} 
              onDelete={() => {
                api.deleteObject("campaign_note", note);
                obj.notes = obj.notes.filter(o => o._id !== note._id);
                setPing(!ping);
              }} 
            />
          </Grid>
        );
      })}
    </Grid>
  );
}
